import { IStaticAccordion } from "../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../Model/Enum/BEE123Enums";

export const EEResourceTemplates: Array<IStaticAccordion> = [
    {
      title: "EE FORMS",
      groups: [
        {
          items: [
            {
              title: "EEA1",
              link: "EEA1.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA2",
              link: "EEA2.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA3",
              link: "EEA3.docx",
              section: LegislationSections.EEForms
            },            
            {
              title: "EEA4",
              link: "EEA4.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA5",
              link: "EEA5.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA6",
              link: "EEA6.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA7",
              link: "EEA7.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA8",
              link: "EEA8.docx",
              section: LegislationSections.EEForms
            },     
            {
              title: "EEA9",
              link: "EEA9.docx",
              section: LegislationSections.EEForms
            },   
            {
              title: "EEA10",
              link: "EEA10.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA11",
              link: "EEA11.docx",
              section: LegislationSections.EEForms
            },              
            {
              title: "EEA12",
              link: "EEA12.docx",
              section: LegislationSections.EEForms
            },             
            {
              title: "EEA13",
              link: "EEA13.docx",
              section: LegislationSections.EEForms
            },         
            {
              title: "EEA14",
              link: "EEA14.docx",
              section: LegislationSections.EEForms
            },  
            {
              title: "EEA15",
              link: "EEA15.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA16A",
              link: "EEA16A.docx",
              section: LegislationSections.EEForms
            },            
            {
              title: "EEA16B",
              link: "EEA16B.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA16C",
              link: "EEA16C.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA16D",
              link: "EEA16D.docx",
              section: LegislationSections.EEForms
            },
            {
              title: "EEA17",
              link: "EEA17.docx",
              section: LegislationSections.EEForms
            },
          ],
        },
      ],
    },
    {
      title: "EE TEMPLATES",
      groups: [
        {
          items: [
            {
              title: "2023 Landing Page Guideline How to Change Organizational Details",
              link: "2023 Landing Page Guideline How to change organizational details.docx",
              section: LegislationSections.EETemplates
            },
            {
              title: "Deviation Form",
              link: "Deviation Form.docx",
              section: LegislationSections.EETemplates
            },
            {
              title: "Deviations Policy",
              link: "Deviations Policy.docx",
              section: LegislationSections.EETemplates
            },
            {
              title: "EE Nomination Notice",
              link: "EE Nomination Notice.doc",
              section: LegislationSections.EETemplates

            },
            {
              title: "Example Committee Constitution",
              link: "Example Committee Constitution.docx",
              section: LegislationSections.EETemplates
            },
            {
              title: "Guidelines on How to Apply for Deregistration",
              link: "Guidelines  on how to apply for deregistration.docx",
              section: LegislationSections.EETemplates
            },
            {
              title: "Letter of Appointment EE Committee",
              link: "Letter of Appointment EE Committee.doc",
              section: LegislationSections.EETemplates
            },
            {
              title: "Letter of Appointment S24",
              link: "Letter of Appointment S24.doc",
              section: LegislationSections.EETemplates
            }
          ],
        },
      ],
    }
  ];
  